import { Directive, ElementRef, HostListener } from '@angular/core';
import { AppInsightsService } from '@sb-tools/typescript/services/app-insights.service';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';

@Directive({ selector: '[appLogToolbarControlsClick]' })
export class LogToolbarControlsClickDirective {
    constructor(
        private elementRef: ElementRef,
        private appInsightsService: AppInsightsService,
        private commonDataService: CommonDataService,
    ) {}

    @HostListener('click', ['$event.target'])
    onClick(targetElement: EventTarget | null) {
        // ignore click on the free space from controls buttons on quill toolbar
        // ignore click on select options

        if (
            !(targetElement instanceof Element) ||
            targetElement === this.elementRef.nativeElement ||
            targetElement.closest('.ql-picker-options')
        ) {
            return;
        }

        const clickedControl = targetElement.closest('button') || targetElement.closest('.ql-picker');
        if (clickedControl?.hasAttribute('data-control')) {
            this.logQuillControlClick(clickedControl.getAttribute('data-control'));
        }
    }

    logQuillControlClick(buttonType: string): void {
        this.appInsightsService.logEvent('Quill control click', {
            type: buttonType,
            ticketSource: 'web',
            community: this.commonDataService.communityName,
        });
    }
}
